// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-32d74a24] .el-autocomplete{width:100%}[data-v-32d74a24] .el-form-item{margin-bottom:0}", ""]);
// Exports
module.exports = exports;
